
import { z } from 'zod';
import { FirstNameSchema, LastNameSchema } from '@shared/user';

export const MIN_PASSWORD_LENGTH = 8;

export const PasswordSchema = z
  .string()
  .min(MIN_PASSWORD_LENGTH, `Use at least ${MIN_PASSWORD_LENGTH} characters.`);

export const SignInInputSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Enter your email address.')
    .email('That doesn’t look like a valid email address.'),
  password: z.string().min(1, 'Enter your password.'),
});

export type SignInInput = z.infer<typeof SignInInputSchema>;

export const ForgotPasswordInputSchema = z.object({
  email: SignInInputSchema.shape.email,
});

export type ForgotPasswordInput = z.infer<typeof ForgotPasswordInputSchema>;

export const SignUpInputSchema = z.object({
  firstName: FirstNameSchema,
  lastName: LastNameSchema,
  email: SignInInputSchema.shape.email,
  password: PasswordSchema,
});

export type SignUpInput = z.infer<typeof SignUpInputSchema>;
